import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import s11 from './Component/s11.png';
import s12 from './Component/s12.png';

function BathroomRemodeling() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${s11})` }}
      >
        <div className="absolute inset-0 bg-[#803333]/80" />
        <div className="relative container mx-auto px-4 py-14 md:py-20 text-center text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 tracking-tight">
            Bathroom Remodeling
          </h1>
          <p className="text-white/85 text-sm md:text-base mb-6 max-w-xl mx-auto">
            Wide variety of styles for a bathroom that looks and works beautifully
          </p>
          <a
            href="/free-estimate"
            className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
          >
            Request an Estimate
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </section>

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <Request />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8 space-y-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                  It&apos;s time to get excited about bathroom remodeling
                </h2>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3">
                  Bathroom remodeling: it&apos;s something every homeowner has to face at some point or another. For some, it&apos;s not as exciting as it can be and we hope to change that by the time you&apos;re finished reading. This project can bring great functionality and beauty to your home in so many ways.
                </p>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                  Since the bathroom is a space that is used multiple times daily, and at all hours, it must function exactly as it should. However, you want it to look its best as well. You can have both and a bathroom remodeling provider can show you exactly how it&apos;s done.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-bold text-[#803333] mb-3">
                  Bathroom remodeling done right
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3">
                  There&apos;s likely one major reason that&apos;s brought you to the decision that bathroom remodeling is necessary. It could be that you need a new sink, toilet, or bathtub. It could be that your faucet or handles are wearing out on the tub or sink.
                </p>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                  The good news is that these, and so much more, are easy to deal with in a bathroom remodel. Not only do we cover these important areas but we can also help with lighting, fixtures, shower installations, moving things around, adding new flooring, or creating new colors and décor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white border-y border-gray-100 py-10 md:py-14">
        <div className="container mx-auto px-4">
          <div className="row g-4 g-lg-5 align-items-center">
            <div className="col-lg-6">
              <img
                src={s12}
                alt="Bathroom remodeling inspiration"
                className="w-full h-auto rounded-2xl shadow-sm"
              />
            </div>
            <div className="col-lg-6">
              <div className="space-y-5">
                <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                  In bathroom remodeling, the work can be as much about making things look wonderful as it is about creating the perfect functionality. For instance, have you found there&apos;s just not enough light for shaving or fixing your hair? Let us know, and we can create lighting that will match your needs perfectly.
                </p>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed m-0">
                  Our bathroom remodeling services are available to you and completely personalized to your specific needs and preferences. Just let us know what&apos;s missing, or what needs to change.
                </p>
                <div>
                  <h3 className="text-lg font-bold text-[#803333] mb-3">
                    All your bathroom remodeling needs can be found here
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3">
                    When you&apos;re ready for bathroom remodeling, Nickle&apos;s Flooring wants you to know you can be excited about it. We offer a bathroom remodeling service and hope to make all your plans come to life after visiting our Cassville, MO showroom.
                  </p>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5">
                    We&apos;ve already done work for residents of Cassville, Shell Knob, Holiday Island, Golden, Eagle Rock, Exeter, Seligman, Purdy, Wheaton, and Washburn — and we look forward to helping you as well.
                  </p>
                  <a
                    href="/free-estimate"
                    className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
                  >
                    Request an Estimate
                    <i className="bi bi-arrow-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BathroomRemodeling;
